import { Country } from 'src/app/shared/models/lookup-data.model';

export interface Address {
    line1: string;
    line2: string;
    suburb: string;
    state: string;
    postcode: string;
    country: string;
    isCurrentAddress: boolean;
}


export interface AddressConfig {
    isAustralianAddress: boolean;
    countries?: Country[];
    title: string;
    titleAdditionalInfo: string;
    isSubmittedApplication?: boolean;
    idPrefix: string;
}

export interface AddressErrors {
    line1?: string;
    line2?: string;
    suburb?: string;
    state?: string;
    postcode?: string;
    country?: string;
    isCurrentAddress?: string;
}

export const AustralianStates = [
    {
      Code: 'NSW',
      Description: 'New South Wales'
    },
    {
      Code: 'QLD',
      Description: 'Queensland'
    },
    {
      Code: 'SA',
      Description: 'South Australia'
    },
    {
      Code: 'TAS',
      Description: 'Tasmania'
    },
    {
      Code: 'VIC',
      Description: 'Victoria'
    },
    {
      Code: 'WA',
      Description: 'Western Australia'
    }
  ];
